import { Injectable } from "@angular/core";
import { Headers } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { AdalHttp } from '../../services/adal.http.service';
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";
import { OnboardUserRequest } from './onboard-user-request';

@Injectable()
export class OnboardingUserService {
    constructor(private http: AdalHttp) {
    }

    onboardUser(onboardUserRequest: OnboardUserRequest): Observable<any> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        let productUrl: string = "/api/user/onboard";
        return this.http.post(productUrl, onboardUserRequest, {
            headers: headers
        })
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

      
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/onboardingUserForgerock/onboard-user.service.ts
 **/